import React from 'react';
import { useIntl } from 'react-intl';
import {
  Button,
  Col,
} from 'reactstrap';

import EmptyStateImage from './components/Image';

import { eventDispatch } from '../../helpers/Events';

const EmptyUploads = () => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Stay on top of new assets' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'View and track all your workspace uploads by date, number of files, and more so you can go directly to what you need when you need it.' })}
        </div>
        <Button
          className="mt-4"
          color="primary"
          onClick={() => { eventDispatch('triggerFileUpload'); }}
        >
          {intl.formatMessage({ defaultMessage: 'Upload some files' })}
        </Button>
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-upload-page.png" />
    </div>
  );
};

export default EmptyUploads;
